const DeviceApiEndpoint = {
    INIT: '/device-manager/init',
};

export default DeviceApiEndpoint;
